import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
    getAllGroups,
    getAllFactoriesByGroupID,
    getItemByItemCategoryForDropDown,
    SaveDirectPurchaseOrder,
    getDirectPurchaseOrderDetails,
    GetDirectPurchaseOrderDetailsByDPOrderID,
    UpdateDirectPurchaseOrder,
    getBudgetCodeDetails,
    GetSKUCategoryNamesByID,
    getSuppliersForDropDownAuto,
    getSuppliersForDropDown,
    DeleteDirectPurchaseOrder,
    DirectPurchaseOrderApproveReject,
    DirectPurchaseOrderReject,
    getMeasuringUnitBySKU,
    getAvailableQuantity,
    GetSupplierVatDetails
}

async function getAllGroups() {
    let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
    let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    let factoryArray = []
    for (let item of Object.entries(response.data)) {
        factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
    }
    return factoryArray;
}

async function getItemByItemCategoryForDropDown(skuCategoryID ,supplierID ) {
    const response = await CommonGet('/api/SKUMaster/GetSKUsByPurchaseTypeInSupplierID', 'skuCategoryID=' + parseInt(skuCategoryID) + '&supplierID=' + parseInt(supplierID));
    return response.data;
}

async function getAvailableQuantity(groupID, factoryID, skuCategoryID, skuMasterID) {
    const response = await CommonPost('/api/Requisition/getAvailableQuantity', 'groupID=' + parseInt(groupID) + '&factoryID=' + parseInt(factoryID) + '&skuCategoryID=' + parseInt(skuCategoryID) + '&skuMasterID=' + parseInt(skuMasterID));
    return response;
}

async function getBudgetCodeDetails() {
    let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes', null);
    let budgetCodeArray = [];
    for (let item of Object.entries(response.data)) {
        budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"];
    }
    return budgetCodeArray;
}

async function SaveDirectPurchaseOrder(generalModelList) {
    const response = await CommonPost('/api/DirectPurchaseOrder/SaveDirectPurchaseOrder', null, generalModelList);
    return response;
}

async function getDirectPurchaseOrderDetails(model) {
    const response = await CommonPost('/api/DirectPurchaseOrder/GetDirectPurchaseOrderDetails', null, model);
    return response;
}

async function GetDirectPurchaseOrderDetailsByDPOrderID(directPurchaseOrderID) {
    const response = await CommonGet('/api/DirectPurchaseOrder/GetDirectPurchaseOrderDetailsByDPOrderID', 'directPurchaseOrderID=' + parseInt(directPurchaseOrderID));
    return response.data;
}

async function UpdateDirectPurchaseOrder(updateModel) {
    const response = await CommonPost('/api/DirectPurchaseOrder/UpdateDirectPurchaseOrder', null, updateModel);
    return response;
}

async function getSuppliersForDropDown(factoryID) {
    var supplierArray = [];
    const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
    for (let item of Object.entries(response.data)) {
        supplierArray[item[1]["supplierID"]] = { name: item[1]["supplierName"], code: item[1]["supplierCode"] }
    }
    return supplierArray;
}

async function getSuppliersForDropDownAuto(factoryID) {
    const response = await CommonGet('/api/AccountingSuppliers/GetSuppliersForDropDown', "factoryID=" + parseInt(factoryID));
    return response.data;
}

async function DeleteDirectPurchaseOrder(directPurchaseOrderID, modifiedBy) {
    const response = await CommonGet('/api/DirectPurchaseOrder/DeleteDirectPurchaseOrder', 'directPurchaseOrderID=' + parseInt(directPurchaseOrderID) + '&modifiedBy=' + parseInt(modifiedBy));
    return response;
}

async function DirectPurchaseOrderApproveReject(directPurchaseOrderID, modifiedBy, statusID) {
    const response = await CommonGet('/api/DirectPurchaseOrder/DirectPurchaseOrderApproveReject', 'directPurchaseOrderID=' + parseInt(directPurchaseOrderID) + '&modifiedBy=' + parseInt(modifiedBy) + '&statusID=' + parseInt(statusID));
    return response;
}

async function DirectPurchaseOrderReject(directPurchaseOrderID, modifiedBy, statusID) {
    const response = await CommonGet('/api/DirectPurchaseOrder/DirectPurchaseOrderReject', 'directPurchaseOrderID=' + parseInt(directPurchaseOrderID) + '&modifiedBy=' + parseInt(modifiedBy) + '&statusID=' + parseInt(statusID));
    return response;
}

async function getMeasuringUnitBySKU(skuMasterID) {
    let response = await CommonGet('/api/DirectPurchaseOrder/GetMeasuringUnitBySKU', 'skumasterID=' + skuMasterID);
    return response.data;
}

async function GetSupplierVatDetails(supplierID) {
    const response = await CommonGet('/api/DirectPurchaseOrder/GetSupplierVatDetails', 'supplierID=' + parseInt(supplierID));
    return response;
}

async function GetSKUCategoryNamesByID(budgetCodeID,groupID,factoryID) {
  let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeID', 'budgetCodeID=' + budgetCodeID +'&groupID=' + groupID +'&factoryID=' + factoryID);
  let categoryArray = [];
  for (let item of Object.entries(response.data)) {
    categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
  }
  return categoryArray;
}